function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "zoom_icn");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icons",
  transform: "translate(-31.000000, -70.000000)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "zoom_icn",
  transform: "translate(44.000000, 83.000000) rotate(180.000000) translate(-44.000000, -83.000000) translate(31.000000, 70.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13,0.5 C6.09644063,0.5 0.5,6.09644063 0.5,13 C0.5,19.9035594 6.09644063,25.5 13,25.5 C19.9035594,25.5 25.5,19.9035594 25.5,13 C25.5,6.09644063 19.9035594,0.5 13,0.5 Z M13,1.5 C19.3512746,1.5 24.5,6.64872538 24.5,13 C24.5,19.3512746 19.3512746,24.5 13,24.5 C6.64872538,24.5 1.5,19.3512746 1.5,13 C1.5,6.64872538 6.64872538,1.5 13,1.5 Z",
  id: "Oval",
  fill: "#DCDCDC"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Line-3",
  fill: "#373737",
  transform: "translate(18.172263, 17.771125) scale(-1, -1) rotate(34.690068) translate(-18.172263, -17.771125) ",
  points: "19.7814734 14.4975152 20.3361736 15.3295655 17.4 17.286 19.562411 20.4846776 18.7339566 21.0447342 16.0083521 17.0129294"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Line-3",
  fill: "#373737",
  transform: "translate(7.584028, 17.771125) scale(1, -1) rotate(34.690068) translate(-7.584028, -17.771125) ",
  points: "9.19323814 14.4975152 9.74793833 15.3295655 6.812 17.286 8.97417569 20.4846776 8.14572135 21.0447342 5.42011681 17.0129294"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Line-3",
  fill: "#373737",
  transform: "translate(18.172263, 8.594654) scale(-1, 1) rotate(34.690068) translate(-18.172263, -8.594654) ",
  points: "19.7814734 5.32104459 20.3361736 6.15309488 17.4 8.11 19.562411 11.308207 18.7339566 11.8682636 16.0083521 7.8364588"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Line-3",
  fill: "#373737",
  transform: "translate(7.584028, 8.594654) scale(-1, -1) rotate(-146.309932) translate(-7.584028, -8.594654) ",
  points: "9.19323814 5.32104459 9.74793833 6.15309488 6.812 8.11 8.97417569 11.308207 8.14572135 11.8682636 5.42011681 7.8364588"
}))));

var SvgZoomIcn = function SvgZoomIcn(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgZoomIcn, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/zoom_icn.6eb4e993.svg";
export { ForwardRef as ReactComponent };